import React from 'react';

import HTMLText from '@swf/components/HTMLText/HTMLText';

import type { CardViewProps } from '../../config/NotificationTypes';

import CardBack from './Template';

const CardBackDefault: React.FC<CardViewProps> = (props) => (
  <CardBack {...props}>
    <HTMLText html={props.cardData.moreInfo} />
  </CardBack>
);

export default CardBackDefault;
